module.exports = __webpack_public_path__ + "static/media/zeus.03adab4a.jpeg";